import { render, staticRenderFns } from "./ExtraServicePrices.vue?vue&type=template&id=4aa2f4d2&scoped=true"
import script from "./ExtraServicePrices.vue?vue&type=script&lang=ts"
export * from "./ExtraServicePrices.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa2f4d2",
  null
  
)

export default component.exports